var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatWidgetIntroIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 263,
    height: 333,
    viewBox: "0 0 263 333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1666",
    x: 0,
    y: 0,
    width: 263,
    height: 333,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#474646",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.214,
    y1: 0.165,
    x2: 0.754,
    y2: 0.913,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200e9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.635,
    y1: 0.204,
    x2: 0.246,
    y2: 0.913,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c2afe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa1616"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Intro_image_2",
    "data-name": "Intro image 2",
    transform: "translate(-958.5 -210.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 958.5, 210.5)",
    filter: "url(#Path_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1666-2",
    "data-name": "Path 1666",
    d: "M13,0H145a13,13,0,0,1,13,13V215a13,13,0,0,1-13,13H13A13,13,0,0,1,0,215V13A13,13,0,0,1,13,0Z",
    transform: "translate(52.5 40.5)",
    fill: "#c9d9f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4653",
    "data-name": "Group 4653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M4.751,0H153.114a4.751,4.751,0,0,1,4.751,4.751V67.238H0V4.751A4.751,4.751,0,0,1,4.751,0Z",
    transform: "translate(1011 251)",
    fill: "#5600ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4652",
    "data-name": "Group 4652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1151.001 257)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 6,
    cy: 5.5,
    rx: 6,
    ry: 5.5,
    transform: "translate(-0.001)",
    fill: "#4e6efb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M123.383,122.7l1.914-1.914a.484.484,0,1,0-.684-.685l-1.914,1.914-1.914-1.914a.484.484,0,0,0-.685.685l1.914,1.914-1.914,1.914a.484.484,0,1,0,.685.685l1.914-1.914,1.914,1.914a.484.484,0,1,0,.685-.685Z",
    transform: "translate(-116.7 -117.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4651",
    "data-name": "Group 4651"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1440",
    "data-name": "Rectangle 1440",
    width: 95,
    height: 6,
    rx: 3,
    transform: "translate(1017 260)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    "data-name": "Rectangle 1460",
    width: 51,
    height: 6,
    rx: 3,
    transform: "translate(1017 272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4650",
    "data-name": "Group 4650"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    "data-name": "Rectangle 1442",
    width: 141,
    height: 3,
    rx: 1.5,
    transform: "translate(1017 296)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    "data-name": "Rectangle 1443",
    width: 104,
    height: 3,
    rx: 1.5,
    transform: "translate(1017 305)",
    fill: "#d6d6d6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4644",
    "data-name": "Group 4644",
    transform: "translate(192 96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(825.439 343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    transform: "translate(-0.44)",
    fill: "#fafafa",
    stroke: "#1450ff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 29,
    rx: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 145,
    height: 28,
    rx: 14,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(947.44 351)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 13,
    height: 13,
    transform: "translate(-0.44)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(0.954 1.266)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 6,
    y2: 5,
    transform: "translate(4.606 0.734)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M12.84,2,9.046,12.84,6.878,7.962,2,5.794Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M.836,0H79.409a.792.792,0,0,1,.836.74V3.7a.792.792,0,0,1-.836.74H.836A.792.792,0,0,1,0,3.7V.74A.792.792,0,0,1,.836,0Z",
    transform: "translate(836 350)",
    fill: "#778294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1457",
    "data-name": "Rectangle 1457",
    d: "M3,0H5A2,2,0,0,1,7,2V3A3,3,0,0,1,4,6H3A3,3,0,0,1,0,3V3A3,3,0,0,1,3,0Z",
    transform: "translate(837 361)",
    fill: "#778294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1458",
    "data-name": "Rectangle 1458",
    d: "M3,0H5A2,2,0,0,1,7,2V3A3,3,0,0,1,4,6H3A3,3,0,0,1,0,3V3A3,3,0,0,1,3,0Z",
    transform: "translate(848 361)",
    fill: "#778294"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4659",
    "data-name": "Group 4659",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4638",
    "data-name": "Group 4638",
    transform: "translate(137.001 99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    transform: "translate(830.999 234)",
    fill: "#f3f3f5",
    stroke: "rgba(255,255,255,0.97)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8,0H119a14,14,0,0,1,14,14v0a14,14,0,0,1-14,14H14A14,14,0,0,1,0,14V2.8A2.8,2.8,0,0,1,2.8,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.017.5H119A13.5,13.5,0,0,1,132.5,14v0A13.5,13.5,0,0,1,119,27.5H14A13.5,13.5,0,0,1,.5,14V3.017A2.517,2.517,0,0,1,3.017.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4615",
    "data-name": "Group 4615",
    transform: "translate(841.5 239.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 106,
    height: 5,
    rx: 1,
    transform: "translate(0.499 0.166)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449",
    "data-name": "Rectangle 1449",
    width: 64,
    height: 5,
    rx: 1,
    transform: "translate(0.499 9.166)",
    fill: "#cfcfcf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4626",
    "data-name": "Group 4626",
    transform: "translate(321.777 -62.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person-circle",
    d: "M53.573,48a5.573,5.573,0,1,0,5.573,5.573A5.579,5.579,0,0,0,53.573,48Zm-1.345,3.13a1.894,1.894,0,0,1,2.688,0,1.8,1.8,0,0,1,.474,1.388,1.818,1.818,0,1,1-3.632,0A1.805,1.805,0,0,1,52.227,51.13Zm1.345,7.158A4.7,4.7,0,0,1,50.2,56.862a3.293,3.293,0,0,1,.941-.9,4.7,4.7,0,0,1,4.868,0,3.292,3.292,0,0,1,.942.9A4.7,4.7,0,0,1,53.573,58.288Z",
    transform: "translate(597.223 334.804)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(652.271 381)",
    fill: "#04a405",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.213,
    cy: 2.213,
    r: 2.213,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.213,
    cy: 2.213,
    r: 1.963,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4660",
    "data-name": "Group 4660",
    transform: "translate(1065 371.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4638-2",
    "data-name": "Group 4638",
    transform: "translate(0 14.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14",
    fill: "#f3f3f5",
    stroke: "rgba(255,255,255,0.97)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0H130.2A2.8,2.8,0,0,1,133,2.8V14a14,14,0,0,1-14,14H14A14,14,0,0,1,0,14v0A14,14,0,0,1,14,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,.5H129.983A2.517,2.517,0,0,1,132.5,3.017V14A13.5,13.5,0,0,1,119,27.5H14A13.5,13.5,0,0,1,.5,14v0A13.5,13.5,0,0,1,14,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4615-2",
    "data-name": "Group 4615",
    transform: "translate(16 5.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448-2",
    "data-name": "Rectangle 1448",
    width: 106,
    height: 5,
    rx: 1,
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449-2",
    "data-name": "Rectangle 1449",
    width: 64,
    height: 5,
    rx: 1,
    transform: "translate(42 9)",
    fill: "#b3bbc4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4626-2",
    "data-name": "Group 4626",
    transform: "translate(122.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person-circle-2",
    "data-name": "person-circle",
    d: "M53.573,48A5.573,5.573,0,1,1,48,53.573,5.579,5.579,0,0,1,53.573,48Zm1.345,3.13a1.894,1.894,0,0,0-2.688,0,1.8,1.8,0,0,0-.474,1.388,1.818,1.818,0,1,0,3.632,0A1.805,1.805,0,0,0,54.918,51.13Zm-1.345,7.158a4.7,4.7,0,0,0,3.376-1.426,3.293,3.293,0,0,0-.941-.9,4.7,4.7,0,0,0-4.868,0,3.292,3.292,0,0,0-.942.9A4.7,4.7,0,0,0,53.573,58.288Z",
    transform: "translate(-47.672 -46.196)",
    fill: "url(#linear-gradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWidgetIntroIcon);
export default __webpack_public_path__ + "static/media/chat-widget-intro-icon.fe9e1ad5e98fbe4d22e46a4ba10a546f.svg";
export { ForwardRef as ReactComponent };